<template>
  <div class="main-wrapper">
    <div>
      <div>
        <img src="../../assets/0001.jpg" width="100%">
      </div>
      <div>
        <img src="../../assets/0003.jpg" width="100%">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IceIceBabyView",
  components: {
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped>
@import "https://fonts.googleapis.com/css?family=Raleway:500|Roboto:300";
@import "../../assets/css/normalize.css";
@import "../../assets/css/atmosphere.css";
@import "../../assets/css/layout.css";

table {
  display: table;
}
.left {
  width: 20vh;
  font-weight: bold;
}

.header-img {
  background: url("../../assets/img/aaron-burden-CKlHKtCJZKk-unsplash.jpg")
    no-repeat;
  background-size: cover;
  padding: 0.5em 4em 5em 4em;
}

.impressum {
  text-align: right;
  font-size: 3em;
}
</style>



// WEBPACK FOOTER //
// src/components/eisart/iceicebaby.vue